<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 12 12"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.86193 0.195262C7.12228 -0.0650874 7.54439 -0.0650874 7.80474 0.195262L11.4714 3.86193C11.7318 4.12228 11.7318 4.54439 11.4714 4.80474C11.2591 5.01705 10.9392 5.05622 10.6872 4.92227L8.57351 7.03596L7.62422 9.56742C7.5908 9.65652 7.5387 9.73744 7.4714 9.80474L6.4714 10.8047C6.21105 11.0651 5.78894 11.0651 5.5286 10.8047L3.66667 8.94281L1.13807 11.4714C0.877722 11.7318 0.455612 11.7318 0.195262 11.4714C-0.0650874 11.2111 -0.0650874 10.7889 0.195262 10.5286L2.72386 8L0.861929 6.13807C0.601579 5.87772 0.601579 5.45561 0.861929 5.19526L1.86193 4.19526C1.92922 4.12797 2.01014 4.07586 2.09925 4.04245L4.63071 3.09315L6.7444 0.979457C6.61044 0.72745 6.64962 0.407571 6.86193 0.195262ZM7.66667 1.94281L5.4714 4.13807C5.40411 4.20536 5.32319 4.25747 5.23408 4.29089L2.70263 5.24018L2.27614 5.66667L6 9.39052L6.42648 8.96404L7.37578 6.43258C7.4092 6.34348 7.4613 6.26256 7.5286 6.19526L9.72386 4L7.66667 1.94281Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  inheritAttrs: false,
};
</script>



// WEBPACK FOOTER //
// src/components/pinning/pin-settings/pin-icon.vue